import { createSlice } from '@reduxjs/toolkit';

// Define the initial state using that type
const initialState = {
  isModalOpen: false,
};

const modalSlice = createSlice({
  name: 'availabilityModal',
  initialState,
  reducers: {
    availabilityToggle: (state) => {
      const newState = state;
      newState.isModalOpen = !state.isModalOpen;
    },
  },
});

export const { availabilityToggle } = modalSlice.actions;

export const selectItems = (state) => state.availabilityModal.isModalOpen;

export default modalSlice.reducer;
